
import { getBasketData, trans } from "utils/helpers";
import './style.scss'
import { ModalForm } from "components/ModalForm/ModalForm";
import { useContext, useEffect, useState } from "react";
import { GroupingPrice } from "components/GroupingPrice/GroupingPrice";
import { CustomerSalesOrder } from "./components/CustomerSalesOrder";
import { CartItem } from "./components/CartItem";
import { LayoutContext } from "layouts/DashboardLayout/context/LayoutContext";
import { Loading } from "components/Loading/loading";

export const CartPage = () => {
    const [showIncreaseDecrease,setShowIncreaseDecrease] = useState<any>(false)
    const [selectedIncreaserDecreaser,setSelectedIncreaserDecreaser] = useState<any>(null)
    const [basketData,setBasketData] = useState<any>([])
    const [loading,setLoading] = useState<any>(false)
    const [checkBoxId,setCheckBox] = useState<any>(null)
    const [showCustomerSalesOrder,setShowCustomerSalesOrder] = useState<boolean>(false)
    const [priceInfo,setPriceInfo] = useState<any>({itemsPrice:0,cartSubtotal:0,countBadge:0,Qty:0})
    const [priceKey,setPriceKey]=useState("")

    const layoutContext = useContext(LayoutContext);


    const priceUpdate = ()=>{
        setLoading(false)
        let newItemsPrice =0
        let newCartSubtotal=0

        let basketData = getBasketData()
        setBasketData(basketData)
        let Qty = 0
        basketData.map(items => {
            Object.values(items.order).map((orders:any) =>{
                const unitPrice=items?.ItemPriceListDetails[0]?.PriceDetails[orders.priceIndex]?.[priceKey+"SalesUnitPrice"]==-1?0:+items?.ItemPriceListDetails[0]?.PriceDetails[orders.priceIndex]?.[priceKey+"SalesUnitPrice"]
                newItemsPrice = newItemsPrice + ((+unitPrice*(100+(items?.TaxObject?.[orders?.OrderItemId?.ItemId]??0)))/100 * +orders.count )
                newCartSubtotal = newCartSubtotal +
                ((( +unitPrice - (+items?.ItemPriceListDetails[0]?.PriceDetails[orders.priceIndex]?.[priceKey+"SalesUnitDiscount"]) ) 
                     *(100+(items?.TaxObject?.[orders?.OrderItemId?.ItemId]??0))/100)*+orders.count)
                Qty = Qty + 1 
                setPriceInfo({itemsPrice:newItemsPrice , cartSubtotal:newCartSubtotal , countBadge:orders.count , Qty:Qty}) 
            })
        })

        setLoading(true)
    }
    
  
    useEffect(()=>{
        priceUpdate()
    },[layoutContext.basket])
    useEffect(() => {
    
        setPriceKey(layoutContext.layoutEcommrceConstraint?.ShowCustomerPrice ? "Customer" :"" )
      }, [layoutContext.layoutEcommrceConstraint]);


    

    return ( <>
            {
            showCustomerSalesOrder &&
            <ModalForm modalHeight={80} title="CustomerSalesOrder" onHide={() => { setShowCustomerSalesOrder(false) }} show={showCustomerSalesOrder}>
                <CustomerSalesOrder basketData={basketData} onHide={() => { setShowCustomerSalesOrder(false) }} mode="create"/>
            </ModalForm>
            }
{/*             {
            showIncreaseDecrease &&(
            <ModalForm modalHeight={80} title={selectedIncreaserDecreaser.title} onHide={() => { setShowIncreaseDecrease(false) }} show={showIncreaseDecrease}>
                <IncreaserDecreaser onHide={()=>{setShowIncreaseDecrease(false) }} object={selectedIncreaserDecreaser} checkBoxHandle={setCheckBox}/>
            </ModalForm>
                )
            } */}
            {
            loading ? 
                <div className="cart w-100 position-relative userSelectNone">
                    <ul className="d-flex border-bottom border-2 my-2 p-1 pb-0">
                        <li className="d-flex position-relative mx-1 pb-2 h-100">
                            <div className="font-size-xl fw-bold">{trans('ShoppingCart')}</div>
                            <div className="me-2 d-flex justify-content-center align-items-center cart__Badge">{basketData.length}</div>
                            <div className="cart__underBadge position-absolute bottom-0 w-100"></div>
                        </li>
                    </ul>
                    <div className="row">
                        <div className="col-md-9 col-12" style={{height:'78vh'}}>
                            <div className="h-100">
                                <ul className="border glassBox cart__list h-100">
                                <li className="d-md-none d-block p-4 pt-2 cart__Factor">
                                        <div className="my-2 cart__Factor__box d-flex justify-content-between">
                                            <div className="d-flex text-muted"><div>{trans('ItemsPrice')}</div><span className="cart__Factor__percent">({priceInfo.Qty})</span></div>
                                        </div>
                                            <div><GroupingPrice value={priceInfo.itemsPrice}/></div>
                                        <div className="cart__Factor__box d-flex justify-content-between my-2 text-customerPrimaryColor">
                                            <div>{trans('discount')}</div>
                                            <div className="d-flex"><div className="cart__Factor__percent">(%{basketData.length && priceInfo.itemsPrice?((priceInfo.itemsPrice - priceInfo.cartSubtotal)*100/priceInfo.itemsPrice).toFixed(2):0})</div><span><GroupingPrice value={priceInfo.itemsPrice - priceInfo.cartSubtotal}/></span></div>
                                        </div>
                                        <div className="cart__Factor__box d-flex justify-content-between align-items-center" >
                                            <div>{trans('CartSubtotal')}</div>
                                            <div><GroupingPrice value={priceInfo.cartSubtotal}/></div>
                                        </div>   
                                    </li>
                                    {basketData.map((items)=>{
                                    return Object.values(items.order).map((orders:any,index)=>(
                                        <CartItem  key={index} index={index} order={orders} item={items} handlePriceUpdate={priceUpdate} handleSelectedIncreaserDecreaser={(e)=>setSelectedIncreaserDecreaser(e)} handleShowIncreaseDecrease={(e)=>setShowIncreaseDecrease(true)}/>
                                        )
                                    )
                                    })}
                                </ul> 
                            </div>
                        </div>
                        {/* desktop mode */}
                        <div className="col-3 d-md-block d-none">
                            <div className="glassBox p-4 w-100" style={{borderRadius:'4px'}}>
                                <ul>
                                    <li className="cart__Factor__box d-lg-flex justify-content-between my-2">
                                        <div className="d-flex text-muted"><div>{trans('ItemsPrice')}</div><span className="cart__Factor__percent">({!!basketData.length?priceInfo.Qty:0})</span></div>
                                        <div><GroupingPrice value={!!basketData.length?priceInfo.itemsPrice:0} styleClass="text-muted"/></div>
                                    </li>
                                    <li className="cart__Factor__box d-lg-flex justify-content-between my-2 text-customerPrimaryColor">
                                        <div>{trans('discount')}</div>
                                        <div className="d-flex"><div className="cart__Factor__percent">(%{!!basketData.length && priceInfo.itemsPrice?((priceInfo.itemsPrice - priceInfo.cartSubtotal)*100/priceInfo.itemsPrice).toFixed(2):0})</div><GroupingPrice value={!!basketData.length?priceInfo.itemsPrice - priceInfo.cartSubtotal:0}/></div>
                                    </li>
                                    {!layoutContext.layoutEcommrceConstraint?.ShowCustomerPrice&&
                                    <li className="cart__Factor__box d-lg-flex justify-content-between my-2 text-customerPrimaryColor">
                                        <div>{trans('customerdiscount')}</div>
                                        <div className="d-flex"><div className="cart__Factor__percent">(%{!!basketData.length && priceInfo.itemsPrice?(layoutContext.layoutEcommrceConstraint?.CustomerDiscount??0).toFixed(2):0})</div><GroupingPrice value={!!basketData.length?(priceInfo.cartSubtotal*((layoutContext.layoutEcommrceConstraint?.CustomerDiscount??0)))/100:0}/></div>
                                    </li>                             
                                    }
                                     <li className="cart__Factor__box d-lg-flex justify-content-between my-2">
                                        <div>{trans('CartSubtotal')}</div>
                                        <div><GroupingPrice value={!!basketData.length?(!layoutContext.layoutEcommrceConstraint?.ShowCustomerPrice?priceInfo.cartSubtotal-(priceInfo.cartSubtotal*((layoutContext.layoutEcommrceConstraint?.CustomerDiscount??0)))/100 : priceInfo.cartSubtotal):0}/></div>
                                    </li>
                                </ul>
                                <button disabled={!basketData.length?true:false} onClick={()=>setShowCustomerSalesOrder(true)} className="w-100 btn btn-customerPrimaryColor bg-customerPrimaryColor mt-3">{trans('Checkout')}</button>
                            </div>
                        </div>
                    </div>
                    <div className="d-md-none d-flex my-2 glassBox align-items-center justify-content-between px-2 py-3 border border-2 cart__footer">
                        <div className="d-flex w-50 align-items-center justify-sm-content-center ">
                            <button disabled={!basketData.length?true:false} onClick={()=>setShowCustomerSalesOrder(true)} className="btn w-100 btn-customerPrimaryColor bg-customerPrimaryColor mt-2">{trans('Checkout')}</button>
                        </div>
                        <div className="d-flex flex-column align-items-end cart__footer__fontSize-lg">
                            <div>{trans('CartSubtotal')}</div>
                            <GroupingPrice value={priceInfo.cartSubtotal}/>
                        </div>
                    </div>
                </div>
                :
                <Loading/>               
            }

    </> );
}
